import { Fragment, memo } from 'react';

import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { DraggableCasinoCards } from './draggableCasinoCards/DraggableCasinoCards';

import { casinoService } from 'v2/api/casinoService';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';

export const Casinos = memo(() => {
  const { data, isLoading, mutate } = useSWR('getCasinos', casinoService.getCasinos);

  return isLoading ? (
    <Loader />
  ) : (
    isNonNullish(data) && (
      <Fragment>
        {isEmpty(data) ? <EmptyPlaceholder /> : <DraggableCasinoCards casinos={data} onRevalidate={mutate} />}
      </Fragment>
    )
  );
});

Casinos.displayName = 'Casinos';
